// src/theme/theme.ts
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  components: {
    MuiInputBase: {
      styleOverrides: {
        input: {
          fontFamily: "'League Spartan', sans-serif",
          fontSize: "20px",
          lineHeight: 1.3,
          fontWeight: 300,
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          fontFamily: "'League Spartan', sans-serif",
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontFamily: "'League Spartan', sans-serif",
        },
      },
    },
  },
  typography: {
    fontFamily: "'League Spartan', sans-serif",
  },
});

export default theme;
